import styles from './DirectionsPage.module.css'

function DirectionsPage() {
  return (
    <div className={styles.directionsPage}>
      <div className={styles.glassCard}>
        <h1>Yol Tarifi</h1>
        <p>Yol tarifi özelliği aktif değildir.</p>
        
        <div className={styles.searchContainer}>
          {/* Başlangıç ve varış noktaları girişleri daha sonra eklenecek */}
        </div>
      </div>
      
      <div className={styles.resultsContainer}>
        {/* Rota sonuçları daha sonra eklenecek */}
      </div>
    </div>
  )
}

export default DirectionsPage
